export default __webpack_public_path__ + "static/media/person_icon.1b18da28.png";